import { gql } from "@apollo/client";

/**
 * The results board's three questions: every tool at once, one tool in full,
 * and the members behind a number.
 */

/** The funnel fields, shared by the board, a panel and every breakdown row. */
const FUNNEL_FIELDS = `
  reached
  sends
  responded
  accepted
  declined
  attendedInvited
  attendedAny
  stillZero
  loggedIn
  stayed
  leaving
  cancelled
  paused
  medianAttended
  eventsAttended
`;

export const OUTREACH_BY_SOURCE = gql`
  query adminOutreachBySource($from: Date, $to: Date) {
    adminOutreachBySource(from: $from, to: $to) {
      source
      ${FUNNEL_FIELDS}
    }
  }
`;

export const OUTREACH_RESULTS = gql`
  query adminOutreachResults(
    $source: OutreachSource
    $from: Date
    $to: Date
    $breakdown: OutreachBreakdown
    $bucket: String
  ) {
    adminOutreachResults(
      source: $source
      from: $from
      to: $to
      breakdown: $breakdown
      bucket: $bucket
    ) {
      source
      current { ${FUNNEL_FIELDS} }
      previous { ${FUNNEL_FIELDS} }
      breakdown {
        bucket
        ${FUNNEL_FIELDS}
      }
      trend {
        bucketStart
        reached
        sends
        responded
        attendedAny
        partial
      }
    }
  }
`;

export const OUTREACH_RESULT_MEMBERS = gql`
  query adminOutreachResultMembers(
    $source: OutreachSource
    $campaign: String
    $from: Date
    $to: Date
  ) {
    adminOutreachResultMembers(source: $source, campaign: $campaign, from: $from, to: $to) {
      userId
      name
      email
      sends
      firstAt
      lastAt
      campaign
      riskThen
      eventsThen
      responded
      attendedAfter
      attendedInvited
      accepted
      declined
      loggedInSince
      lastLoginAt
      endsAt
      membership
    }
  }
`;
